import image from '~/components/atoms/a-images/a-image-v2.data'

export default {
  ...image,
  component: 'm-media',
}
